import styled from "styled-components";
import { GAMBLE_STYLED_PROPS } from "./interface";

export const Main = styled.main<GAMBLE_STYLED_PROPS>`
  text-transform: uppercase;
  font-size: 12px;
  color: ${({ colors }) => colors.secondaryBackground};
  text-align: center;
  overflow-x: hidden;
  min-width: 315px;
  h3 {
    margin: 1px 0;
    font-size: 12px;
  }
`;
